"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clickJump = exports.reminder = exports.productDetailAppLink = exports.getMobileProductUrl = exports.getMobileUrl = exports.searchLink = exports.categoryLink = exports.detailLink = exports.generateAddress = exports.login = exports.loginLink = void 0;
var ezbuyapp_1 = require("utils/browser/ezbuyapp");
var debug_1 = require("utils/debug");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var WebSiteStore_1 = require("mobile/models/WebSiteStore");
var doAppRedirect = function doAppRedirect(href) {
    window.location.href = href;
};
exports.loginLink = function (openMode, title) {
    return exports.generateAddress("", "login", { openMode: openMode, title: title });
};
exports.login = function login(openMode, title) {
    doAppRedirect(exports.loginLink(openMode, title));
};
exports.generateAddress = function (url, host, params) {
    var linkHead = "";
    for (var key in params) {
        if (key === "ezspm") {
            return url + "?ezspm=" + params["ezspm"];
        }
    }
    return url;
    var paramStr = "";
    var paramStrArray = [];
    if (typeof params !== "undefined") {
        for (var key in params) {
            if (typeof params[key] !== "undefined") {
                if (key === "ezspm") {
                    paramStrArray.push(encodeURIComponent(key) + "=" + params[key]);
                }
                else {
                    paramStrArray.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
                }
            }
        }
    }
    if (paramStrArray.length > 0) {
        paramStr = "?" + paramStrArray.join("&");
    }
    return linkHead + host + paramStr;
};
exports.detailLink = function (url, uri, previewinfo, type, openMode, title, ezspm, list) {
    if (type === void 0) { type = "normal"; }
    return exports.generateAddress(url, "productDetail", {
        uri: uri,
        previewinfo: previewinfo,
        type: type,
        openMode: openMode,
        title: title,
        ezspm: ezspm,
        list: list
    });
};
exports.categoryLink = function (url, id, type, title, ezspm) {
    return exports.generateAddress(url, "category", { id: id, type: type, title: title, ezspm: ezspm });
};
exports.searchLink = function (url, keyword, resultonly, openMode, title, shipto, ezspm) {
    return exports.generateAddress(url, "search", { keyword: keyword, resultonly: resultonly, openMode: openMode, title: title, shipto: shipto, ezspm: ezspm });
};
exports.getMobileUrl = function (url, ezspm) {
    var result = url;
    if (url.indexOf("/product/") > -1) {
        var urlArr = url.split("/product/");
        var pathData = urlArr[1];
        var gpidArr = /^(\d+)(.html)?/i.exec(pathData);
        if (gpidArr && gpidArr.length > 1) {
            var gpid = gpidArr[1];
            result = exports.detailLink(url, gpid, undefined, undefined, undefined, undefined, ezspm);
        }
    }
    else if (url.indexOf("/categories/") > -1) {
        if (!ezbuyapp_1.default.isSupportBannerLink) {
            var urlArr = url.split("/categories/");
            var pathData = urlArr[1];
            var id = 0;
            if (pathData.indexOf("?")) {
                id = Number(pathData.split("?")[0]);
            }
            else {
                id = Number(pathData);
            }
            result = exports.categoryLink(url, id, undefined, undefined, ezspm);
        }
    }
    else if (url.indexOf("/category") > -1) {
        if (!ezbuyapp_1.default.isSupportBannerLink) {
            if (url.indexOf("keywords") > -1) {
                var keywords_1 = "";
                var pathData = [];
                var params = url.split("?")[1];
                if (params) {
                    pathData = params.split("&");
                    pathData.forEach(function (item) {
                        if (item.indexOf("keywords") > -1) {
                            keywords_1 = decodeURIComponent(item.split("=")[1]);
                        }
                    });
                }
                result = exports.searchLink(url, keywords_1, undefined, undefined, undefined, undefined, ezspm);
            }
            else if (url.indexOf("keyword") > -1) {
                var keywords_2 = "";
                var pathData = [];
                var params = url.split("?")[1];
                if (params) {
                    pathData = params.split("&");
                    pathData.forEach(function (item) {
                        if (item.indexOf("keyword") > -1) {
                            keywords_2 = decodeURIComponent(item.split("=")[1]);
                        }
                    });
                }
                result = exports.searchLink(url, keywords_2, undefined, undefined, undefined, undefined, ezspm);
            }
            else {
                var urlArr = url.split("/category/");
                var pathData = urlArr[1];
                var arr = /^(\d+)(\?)?/i.exec(pathData);
                if (arr && arr.length > 1) {
                    var categoryId = Number(arr[1]);
                    result = exports.categoryLink(url, categoryId, undefined, undefined, ezspm);
                }
            }
        }
    }
    else {
        if (!/^https?:\/\//.test(url)) {
            url = location.protocol + "//" + location.hostname + url;
        }
        result = url;
    }
    return result;
};
exports.getMobileProductUrl = function (gpid) {
    if (gpid === void 0) { gpid = "110"; }
    var host = debug_1.isLocalDevelop() ? isomorphismConstant_1.default.mobileUATUrlMap[isomorphismConstant_1.default.countryCode] : location.origin;
    return host + "/product/" + gpid + ".html";
};
exports.productDetailAppLink = function (uri, previewinfo, type, openMode, title, ezspm, list) {
    if (type === void 0) { type = "normal"; }
    var url = exports.getMobileProductUrl(uri);
    return exports.generateAddress(url, "productDetail", {
        uri: uri,
        previewinfo: previewinfo,
        type: type,
        openMode: openMode,
        title: title,
        ezspm: ezspm,
        list: list
    });
};
exports.reminder = function (title, description, startTime, endTime, type) {
    if (type === void 0) { type = "add"; }
    doAppRedirect(exports.generateAddress("", "reminder", { title: title, description: description, startTime: startTime, endTime: endTime, type: type }));
};
exports.clickJump = function (link) {
    link = WebSiteStore_1.getStore().replaceUrl(link);
    window.open(link);
};
